import React, { useState } from 'react';
import { signInWithEmailAndPassword, signInWithPopup, OAuthProvider } from 'firebase/auth';
import { auth } from '../firebaseConfig/firebase';
import { NavLink, useNavigate } from 'react-router-dom'
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import logo from './images/logo.png';


const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loader, setLoader] = useState({ microsoftLoading: false });


    const handleMicrosoftLogin = (e) => {
        e.preventDefault();
        //setLoader(prevState => ({ ...prevState, microsoftLoading: true }));
        const provider = new OAuthProvider('microsoft.com').setCustomParameters({
            tenant: 'escaces.onmicrosoft.com'
        });

        signInWithPopup(auth, provider)
            .then(data => {
                console.log(data);


                navigate("/")
                //setLoader(prevState => ({ ...prevState, microsoftLoading: false }));
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage)
            });
    }



    return (
        <div style={{
            backgroundColor: '#f8f9fa',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center'
        }}>
            <Container>
                <Row className="justify-content-md-center">
                    <Col md={5} lg={4}>
                        <Card className="shadow-sm border-0 p-4 pt-5 pb-5">
                            <Card.Body className="text-center">

                                {/* Logo Section */}
                                <div className="mb-5">
                                    <img
                                        src={logo}
                                        alt="Logo ESCAC"
                                        style={{ width: '180px', height: 'auto' }}
                                    />
                                </div>

                                {/* Info Text */}
                                <div className="mb-4">
                                    <h4 className="fw-bold text-dark">Área Privada</h4>
                                    <p className="text-muted small">
                                        Acceso exclusivo mediante cuenta institucional.
                                    </p>
                                </div>

                                {/* Login Button */}
                                <form>
                                    <Button
                                        variant="dark"
                                        size="lg"
                                        className="w-100 py-3 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                                        onClick={handleMicrosoftLogin}
                                        style={{ borderRadius: '8px', transition: 'all 0.3s' }}
                                    >
                                        {/* Icono de Microsoft (opcional con SVG o FontAwesome) */}
                                        <svg width="20" height="20" viewBox="0 0 23 23" fill="white">
                                            <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zm12.6 0H12.6V0H24v11.4z" />
                                        </svg>
                                        <span>Entrar</span>
                                    </Button>
                                </form>

                            </Card.Body>
                        </Card>

                        {/* Footer / Enlace de soporte */}
                        <div className="text-center mt-4">
                            <p className="text-muted small" style={{ letterSpacing: '1px' }}>
                                ESCOLA SUPERIOR DE CINEMA i AUDIOVISUALS DE CATALUNYA
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Login